export enum MobilePermissionPageKey {
  IssueFormRead = 'issue-form-read', // 问题单详情
  ProduceIssue = 'mobile-produce-issue', // 问题单详情
}
